import MenuOpciones from '../globales/MenuOpciones';
import { Link } from 'react-router-dom';
const MenuPrincipal = () => {
  const menu = MenuOpciones();
  return (
    <div className="lg:h-screen p-10">
      <h2 className="text-center text-negro poppins-700 text-24 ">Elige la  historia que quieres leer </h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 lg:grid-rows-2 gap-4 mt-14 h-90">
        {
          menu.map((item, index) =>
            <Link 
              key={index} 
              className="thumbs-menu img-cover-center"
              style={{ backgroundImage:'url(' + require(`../../images/fondos-menu/menu${index}.png`).default + ')'}} 
              to={item.link}>
                <div>
                  <p className={`${index === 0 && 'w-4/6'} ${index === 1 && 'w-7/12'}  poppins-700 text-18 pb-3`}>{item.titulo}</p>
                  <hr className="w-10/12 border-negro "/>
                  <p className="poppins-300 py-3">{item.ciudad} - {item.departamento} </p>
                </div>
                
            </Link>
          )
        }
      </div>
    </div>
  )
}

export default MenuPrincipal;